<template>
    <div class="rd">
        <div class="pagina">
            <header class="paginakop">
                <div class="tekst">
                    <h1>Experiences</h1>
                    <p>Everything a team can book: duration, code and where it runs. Open one to set it on, demo or off per X-Cube.</p>
                </div>
            </header>

            <p v-if="loading" class="rd-laden">Loading experiences...</p>

            <section v-else class="paneel">
                <div v-if="sortedExperiences.length" class="tabel-wikkel">
                    <table class="tabel">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Code</th>
                                <th class="rechts">Duration</th>
                                <th>Flexible</th>
                                <th>For</th>
                                <th><span hidden>Open</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="exp in sortedExperiences" :key="exp.id" class="klikbaar" @click="openExperience(exp)">
                                <td>{{ exp.name }}</td>
                                <td class="num">{{ exp.code }}</td>
                                <td class="num rechts nowrap">{{ exp.duration }} min</td>
                                <td>{{ exp.flexible ? "Yes" : "No" }}</td>
                                <td>
                                    <span class="tags">
                                        <span v-for="t in expTypes(exp)" :key="t" class="tag-type">{{ t.toUpperCase() }}</span>
                                    </span>
                                </td>
                                <td class="rechts">
                                    <button class="btn btn-stil btn-sm" type="button" @click.stop="openExperience(exp)">Manage</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="leeg">
                    <h2>No experiences</h2>
                    <p>No experiences are configured yet.</p>
                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { getExperiencesSimple } from "../../api/graphql/experiences";

const router = useRouter();
const experiences = ref([]);
const loading = ref(false);

const expTypes = (exp) =>
    ["xcube", "xpod", "xkiosk", "xtend"].filter((t) => exp.flexible || exp.application?.[`type_for_${t}`]);

const sortedExperiences = computed(() =>
    experiences.value.slice().sort((a, b) => (a.name || "").localeCompare(b.name || "")),
);

const openExperience = (exp) => {
    router.push({ name: "experience", params: { id: exp.id } });
};

onMounted(async () => {
    loading.value = true;
    experiences.value = await getExperiencesSimple();
    loading.value = false;
});
</script>
